exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cheetah-grid__error-message-element {\n\tborder-top: solid 1px #FF1744;\n\tcolor: #ff1744;\n}", ""]);

// exports
